import { render, staticRenderFns } from "./StartWdr.vue?vue&type=template&id=68eec228&scoped=true&"
import script from "./StartWdr.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartWdr.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StartWdr.vue?vue&type=style&index=0&id=68eec228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eec228",
  null
  
)

export default component.exports